import {
  BodyPostStreetviewLocalAuthorityData, LocalAuthorityGeoJsonFeatureResponse, StreetviewLocalAuthorityDataResponse,
} from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { SelectedFilters } from '../../types/filters.type';
import {
  AdapterInterface, FrontendGeoJsonFeature, MapHeadlines, StreetviewAreaData,
} from '../../types/global';
import adaptFilterRequest from './adaptFilterRequest';

import BaseAdapter from './baseAdapter';

export default class PostStreetviewLocalAuthorities extends BaseAdapter<StreetviewLocalAuthorityDataResponse> implements AdapterInterface {
  rawResponse: StreetviewLocalAuthorityDataResponse;

  modifiedRequest: BodyPostStreetviewLocalAuthorityData;

  async adaptResponse(request: { data: SelectedFilters, signal: AbortSignal }): Promise<StreetviewAreaData> {
    const formattedRequest = this.adaptRequest(request.data);

    await this.fetchApiResponse('/api/streetview-local-authority-data', HTTPMethod.Post, formattedRequest, request.signal);
    return this.displayResponse();
  }

  displayResponse(): StreetviewAreaData {
    const mapHeadlines: MapHeadlines[] = this.rawResponse.map_headlines.map((headline) => ({
      displayName: headline.display_name,
      description: headline.description,
      value: headline.value,
    }));

    const geoJsonFeatures: FrontendGeoJsonFeature[] = this.rawResponse.geo_json_features.map(
      (localAuthority: LocalAuthorityGeoJsonFeatureResponse) => ({
        type: localAuthority.type,
        id: localAuthority.id,
        geometry: localAuthority.geometry,
        properties: {
          name: localAuthority.properties.local_authority_name,
          longitude: localAuthority.properties.longitude,
          latitude: localAuthority.properties.latitude,
          householdCount: localAuthority.properties.household_count,
        },
      }),
    );

    return { geoJsonFeatures, mapHeadlines };
  }

  adaptRequest(selectedFilters: SelectedFilters): BodyPostStreetviewLocalAuthorityData {
    this.modifiedRequest = adaptFilterRequest(selectedFilters);
    return this.modifiedRequest;
  }
}
